export { default } from "./related-item-list";
